import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import MyStudiesPageContent from "app/components/study/mystudies/MyStudiesPageContent";

const MyStudiesPage = (props) => {
  const { t } = useTranslation();
  return (
    <Page
      hasDrawer={false}
      pageTitle={t("pageTitle.myStudies")}
      hasBackButton={false}
      contentComponent={MyStudiesPageContent}
      {...props}
    />
  );
};

export default MyStudiesPage;
